import React, { useCallback, useMemo } from "react";
import {
  IconButton,
  Typography,
  makeStyles,
  createStyles,
  Button,
} from "@material-ui/core";
import { subMonths, addMonths, format } from "date-fns";
import { useHistory } from "react-router-dom";

import LeftArrowIcon from "@material-ui/icons/KeyboardArrowLeft";
import RightArrowIcon from "@material-ui/icons/KeyboardArrowRight";

import DatePicker from "../common/DatePicker";
import { getWarekiForMonth } from "../../helper/JapanDate";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    headerDate: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    todayButton: {
      marginRight: theme.spacing(1),
    },
    titleCenter: {
      display: "flex",
      alignItems: "center",
    },
    titleLeft: {
      marginLeft: theme.spacing(1),
    },
    titleRight: {
      marginRight: theme.spacing(1),
    },
  })
);

export default function CalendarHeader({ setTargetDate, targetDate }) {
  const classes = useStyles();
  const history = useHistory();
  const headerDate = useMemo(() => getWarekiForMonth(targetDate), [targetDate]);

  const handleChangeTargetDate = useCallback(
    (date) => {
      setTargetDate(date);
      history.replace({
        pathname: history.location.pathname,
        state: { defaultTargetDate: date },
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history]
  );

  const setPrevMonth = useCallback(
    (current) => {
      handleChangeTargetDate(subMonths(current, 1));
    },
    [handleChangeTargetDate]
  );

  const setNextMonth = useCallback(
    (current) => {
      handleChangeTargetDate(addMonths(current, 1));
    },
    [handleChangeTargetDate]
  );

  const handleClickToday = useCallback(() => {
    if (format(targetDate, "yyyyMMdd") === format(new Date(), "yyyyMMdd")) {
      return;
    }

    handleChangeTargetDate(new Date());
  }, [handleChangeTargetDate, targetDate]);

  return (
    <div className={classes.headerDate}>
      <IconButton
        size="small"
        onClick={() => setPrevMonth(targetDate)}
        className={classes.titleLeft}
      >
        <LeftArrowIcon />
      </IconButton>

      <div className={classes.titleCenter}>
        <Button
          variant="outlined"
          size="small"
          onClick={handleClickToday}
          className={classes.todayButton}
        >
          今日
        </Button>

        <Typography>{headerDate}</Typography>

        <DatePicker value={targetDate} onChange={handleChangeTargetDate} />
      </div>

      <IconButton
        size="small"
        onClick={() => setNextMonth(targetDate)}
        className={classes.titleRight}
      >
        <RightArrowIcon />
      </IconButton>
    </div>
  );
}
